export const TESTERS_SELECTION_DURATION_HOURS: number = 4;
